var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-layout h-layout-full-height h-layout-blank"},[_c('div',{staticClass:"h-layout-content"},[_c('main',{staticClass:"h-o-main-content"},[_c('div',{staticClass:"container-lg"},[_c('router-view')],1)])]),_c('global-alert',{attrs:{"disable-notification":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }